import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHeyComponent } from './simple-icons-hey.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHeyComponent ],
    exports:      [ SimpleIconsHeyComponent ],
    bootstrap:    []
})
export class SimpleIconsHeyModule {}
